import { AuthSectionTemplate } from "./template";


export const AuthSection = (): JSX.Element => {
  return <AuthSectionTemplate />;
};